(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-kim"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mega-menu-kim')) {
  customElements.define('mega-menu-kim', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.tabs = [...this.querySelectorAll('[data-kim-tab]')];
      this.panels = [...this.querySelectorAll('[data-kim-panel]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'touch') this.activate(index);
        }, options);
        tab.addEventListener('focus', () => this.activate(index), options);
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) {
            event.preventDefault();
            this.tabs[next].focus();
          }
        }, options);
      });
      this.activate(0);
      this.setAttribute('data-ready', '');
    }
    activate(index) {
      this.active = index;
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-expanded', String(i === index));
      });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
